import type { Alias } from '@ps/web-core-store';
import { generatePath } from '@ps/web-core-utils';
import React from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { Redirect as RouterRedirect, useLocation, withRouter } from 'react-router';

import { select } from '@swf/core/store';

interface BaseProps extends RouteComponentProps {
  statusCode?: 301 | 302;
}

interface AliasRedirectProps extends BaseProps {
  alias: Alias;
  values?: Record<string, string | number | boolean | undefined>;
}
interface UrlRedirectProps extends BaseProps {
  url: string;
}

type Props = AliasRedirectProps | UrlRedirectProps;

const Redirect: React.FC<Props> = ({ statusCode = 301, staticContext = {}, ...props }) => {
  const aliases = useSelector(select.cms.getAliases);
  const activeAlias = useSelector(select.cms.getActiveAlias);
  const { search } = useLocation();

  staticContext.statusCode = statusCode;

  if ('url' in props) return <RouterRedirect to={`${props.url}${search}`} />;

  const { alias, values = {} } = props;
  const path = aliases[alias];

  return path && alias !== activeAlias ? (
    <RouterRedirect to={`${generatePath(path, values)}${search}`} />
  ) : null;
};

export default withRouter(Redirect);
